import { styled } from 'stitches.config'

export const RawBenefitsRoot = styled('div', {
  backgroundColor: '$accent-white',
  width: '100%',

  '& li > a': {
    textDecoration: 'none',
  },

  '& a': {
    textDecoration: 'underline',
  },

  '& a.layout-cta': {
    textDecoration: 'none',
  },

  '& a.cta': {
    textDecoration: 'none',
    display: 'none',
  },

  '& a.hero': {
    display: 'block'
  },

  '@bp2': {
    'a.cta': {
      display: 'block',
    },
  },
})

export const CopyColumnHeader = styled('h2', {
  fontSize: '$h3',
  letterSpacing: '$h3',
  lineHeight: '$h3',
  textAlign: 'center',
  margin: 'auto',
  '@bp2': {
    fontSize: '$h1',
    letterSpacing: '$h1',
    lineHeight: '$h1',
    textAlign: 'left',
  },
})
